// store
import storage from '../../storage/localStorage';

const walkthroughStorage = (walkthroughName) =>
  storage(`/gohalo/walkthrough/${walkthroughName}`);

export default walkthroughStorage;
